import React, { useState, useEffect, useRef, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { AsyncPaginate } from 'react-select-async-paginate';
import * as XLSX from "xlsx-js-style";

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const UnitRevenueLoss = () => {
    const apiService = new LeaseApiService();
    const ITEMS_PER_PAGE = 100
    const gridRef = useRef();
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [leaseList, setLeaseList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [leaseTypeList, setLeaseTypeList] = useState([]);
    const [formData, setFormData] = useState({
        property: "",
        unitNo: "",
        from: "",
        to: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();

        const today = new Date();
        const fromDate = new Date(today);
        setFormData((prev) => ({
            ...prev,
            from: formatDate(fromDate),
            to: formatDate(fromDate),
        }));
    }, []);
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            const addAllOption = (list) => [{ value: 'All', text: 'All' }, ...list || []];
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            // let pm = formData.leasePM.join("/")
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("FromDate", formData?.from || updatedValue);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("Unit", formData?.unitNo?.label || "All");
            const res = await apiService.getApiParamater("UNIT_REVENUE_LOSS_REPORT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setRowData(result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords || pageSize || 50);
            params.append("FromDate", formData?.from || updatedValue);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            params.append("Unit", formData?.unitNo?.label || "All");
            const res = await apiService.getApiParamater("UNIT_REVENUE_LOSS_REPORT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const columnDefs = [

        { headerName: "Property Name", field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 300, pinned: "left" },
        { headerName: "Unit No", field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 180, },
        { headerName: "Unit Class", field: "unitClass", filter: true, floatingFilter: true, suppressMovable: true, width: 180, },
        { headerName: "Vacated On", field: "vacatingDate", filter: true, floatingFilter: true, suppressMovable: true, width: 180 },
        { headerName: "Days", field: "noOfDays", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        {
            headerName: "Rent per Month", field: "rentPerMonth", filter: true, floatingFilter: true, suppressMovable: true, width: 150,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 3)
        },
        {
            headerName: "Total Revenue Loss", field: "estimatedRevenueLoss", filter: true, floatingFilter: true, suppressMovable: true, width: 200,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers || 3)
        },
    ]
    const handleClearFilters = () => {
        setUnitList([])
        setRowData([])
        const today = new Date();
        const fromDate = new Date(today);
        setFormData({
            property: "",
            unitNo: "",
            from: formatDate(fromDate),
            to: formatDate(fromDate),
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const propertyValue = value?.value === 'All' ? null : value?.value;
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
            setFormData(prev => ({ ...prev, [name]: value }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportColumns = [
        { header: "Property Name", dataKey: "propertyName" },
        { header: "Unit No", dataKey: "unitNo" },
        { header: "Unit Class", dataKey: "unitClass" },
        { header: "Vacated On", dataKey: "vacatingDate" },
        { header: "Days", dataKey: "noOfDays" },
        { header: "Rent per Month", dataKey: "rentPerMonth", numeric: true },
        { header: "Total Revenue Loss", dataKey: "estimatedRevenueLoss", numeric: true },
    ];
    const exportPDF = () => {
        if (!exportData?.length) {
            toast.warning("No data to export");
            return;
        }

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Available Unit Revenue Loss Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `As of Date: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        const totalsRow = exportColumns.map((col, index) => {
            if (index === 0) return "Total";
            if (col.numeric) {
                return (exportData.reduce((sum, item) => sum + (Number(item[col.dataKey]) || 0), 0)).toFixed(3);
            }
            return "";
        });

        const numericColumnStyles = {};
        exportColumns.forEach((col, i) => {
            if (col.numeric) numericColumnStyles[i] = { halign: "right" };
        });

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col =>
                    col.numeric ? (Number(row[col.dataKey]) || 0).toFixed(3) : normalizeValue(row[col.dataKey])
                )
            ),
            foot: [totalsRow],
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            footStyles: {
                fillColor: [240, 237, 245],
                textColor: 0,
                fontStyle: "bold",
                halign: "center",
            },
            columnStyles: numericColumnStyles,
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save(`Unit_Revenue_Loss_Report_${moment().format("DD-MMM-YYYY_HH-mm-ss")}.pdf`);
    };
    const exportExcel = () => {
        if (!exportData?.length) {
            toast.warning("No data to export");
            return;
        }

        const dataRows = exportData.map(item =>
            exportColumns.map(col =>
                col.numeric ? Number(item[col.dataKey]) || 0 : normalizeValue(item[col.dataKey])
            )
        );

        const totalsRow = exportColumns.map((col, index) => {
            if (index === 0) return "Total";
            if (col.numeric) {
                return exportData.reduce((sum, item) => sum + (Number(item[col.dataKey]) || 0), 0);
            }
            return "";
        });

        const worksheet = XLSX.utils.aoa_to_sheet([
            [`AVAILABLE UNIT REVENUE LOSS REPORT (As of Date: ${moment(formData?.to).format("DD-MMM-YYYY")})`],
            exportColumns.map(col => col.header),
            ...dataRows,
            totalsRow,
        ]);

        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: exportColumns.length - 1 } },
        ];

        // Auto width for every column based on header/data length
        worksheet["!cols"] = exportColumns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map(r => String(r[i] ?? "").length),
                String(totalsRow[i] ?? "").length
            );
            return { wch: Math.min(Math.max(maxLength + 3, 12), 35) };
        });

        worksheet["!rows"] = [{ hpt: 28 }, { hpt: 30 }];
        worksheet["!freeze"] = { ySplit: 2 };

        const borderStyle = {
            top: { style: "thin", color: { rgb: "FFD9D9D9" } },
            bottom: { style: "thin", color: { rgb: "FFD9D9D9" } },
            left: { style: "thin", color: { rgb: "FFD9D9D9" } },
            right: { style: "thin", color: { rgb: "FFD9D9D9" } },
        };

        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            };
        }

        exportColumns.forEach((column, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF666666" } },
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                border: borderStyle,
            };
        });

        dataRows.forEach((row, r) => {
            exportColumns.forEach((col, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;
                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: col.numeric ? "right" : "left" },
                    border: borderStyle,
                };
                if (col.numeric) {
                    cell.t = "n";
                    // Match the grid's plain toFixed(3) output — no thousand separators
                    cell.z = "0.000";
                }
            });
        });

        const totalsRowIndex = dataRows.length + 2;
        exportColumns.forEach((col, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: totalsRowIndex, c })];
            if (!cell) return;
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FF000000" } },
                fill: { fgColor: { rgb: "FFF0EDF5" } },
                alignment: { vertical: "center", horizontal: col.numeric ? "right" : "left" },
                border: borderStyle,
            };
            if (col.numeric) {
                cell.t = "n";
                cell.z = "0.000";
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Unit Revenue Loss Report");
        XLSX.writeFile(workbook, `Unit_Revenue_Loss_Report_${moment().format("DD-MMM-YYYY_HH-mm-ss")}.xlsx`);
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group d-flex align-items-center flex-wrap gap-4">
                            <div className="d-flex" style={{ minWidth: 400 }}>
                                <label htmlFor="validationCustom18" className="form-label">Property </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList
                                        ?.slice()
                                        ?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex" style={{ minWidth: 320 }}>
                                <label htmlFor="validationCustom18" className="form-label">Unit No </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList
                                        ?.slice()
                                        ?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex" style={{ minWidth: 200 }}>
                                <label className="form-label">As on Date</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-1 ms-auto">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2' style={{ minWidth: 120 }}>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2"
                                        style={{ minWidth: 120 }}
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2"
                                    style={{ minWidth: 120 }}
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">Available Unit Revenue Loss Report</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default UnitRevenueLoss;
